import { ConfigHelper } from "./helpers/config-helper";
import { getHost, getOs, getProtocol, getVersion } from "./utils/device";

export default class API {
    /**
     * register device to an API
     * @param {*} params
     * @returns
     */
    static async register(params = {}) {
        const { registrationHost = getHost(), verBBE = "21072914.base", pSetup, token, service, packageName } = params;
        let endpoint = "";
        if (!registrationHost.match(/^https?:\/\//)) {
            endpoint = `${getProtocol()}//`;
        }
        endpoint += `${registrationHost}/eebrowser/bbe_prod/index.php?`;
        if (token) {
            const url =
                endpoint +
                new URLSearchParams({
                    bbe_prod_version: verBBE,
                    bbe_prod_request_action: "index",
                    bbe_prod_request_controller: "pushRegistrationService",
                    psetup: pSetup,
                    machine_id: await ConfigHelper.getDeviceId(),
                    package_id: packageName,
                    reg_id: token,
                    os: getOs(),
                    service: service,
                    sw_version: getVersion()
                });
            console.log(`Register device: ${token} on ${service}`);
            try {
                const response = await fetch(url);
                const json = await response.json();
                console.log(`API answer: ${json.message}`);
                return json;
            } catch (e) {
                console.warn(`Failed to register ${token} to ${url}`);
            }
        } else {
            console.warn("Token is undefined");
        }

        return {};
    }
}
